"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var Permission_1 = require("../model/Permission");

var Role_1 = require("../model/Role");

var User_1 = require("../model/User");

var SubstitutedUserConverter_1 = require("./SubstitutedUserConverter");

var UserProfileConverter_1 = require("./UserProfileConverter");
/**
 * Default implementation of user profile converter.
 *
 * @author Radek Beran
 */


var UserProfileConverterImpl =
/*#__PURE__*/
function (_UserProfileConverter) {
  _inherits(UserProfileConverterImpl, _UserProfileConverter);

  function UserProfileConverterImpl(substitutedUserConverter) {
    var _this;

    _classCallCheck(this, UserProfileConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserProfileConverterImpl).call(this));
    _this._substitutedUserConverter = substitutedUserConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(UserProfileConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new User_1.User(conversions.documentToClassId(source), source.username, conversions.asObjectList(source, 'roles', function (roleDoc) {
        return new Role_1.Role(roleDoc.name);
      }), conversions.asObjectList(source, 'permissions', function (permissionDoc) {
        return new Permission_1.Permission(permissionDoc.name);
      }), conversions.asObjectOpt(source, 'substitutedUser', function (doc) {
        return _this2._substitutedUserConverter.toObject(doc, conversions);
      }), source.name, source.firstName, source.lastName, source.email, utils_1.Utils.isValueMissing(source.lastLogin) ? null : conversions.toDate(source.lastLogin));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        username: source.username
      });
      Object.assign(result, {
        roles: conversions.asObjectArray(source, 'roles', function (role) {
          return {
            name: role.name
          };
        })
      });
      Object.assign(result, {
        permissions: conversions.asObjectArray(source, 'permissions', function (permission) {
          return {
            name: permission.name
          };
        })
      });
      Object.assign(result, {
        substitutedUser: source.substitutedUser !== null ? this._substitutedUserConverter.toDocument(source.substitutedUser, conversions) : null
      });
      Object.assign(result, {
        name: source.name
      });
      Object.assign(result, {
        firstName: source.firstName
      });
      Object.assign(result, {
        lastName: source.lastName
      });
      Object.assign(result, {
        email: source.email
      });
      Object.assign(result, {
        lastLogin: source.lastLogin !== null ? conversions.fromDate(source.lastLogin) : null
      });
      return result;
    }
  }]);

  return UserProfileConverterImpl;
}(UserProfileConverter_1.UserProfileConverter);

UserProfileConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SubstitutedUserConverter_1.SubstitutedUserConverter])], UserProfileConverterImpl);
exports.UserProfileConverterImpl = UserProfileConverterImpl;